import { useIgnoreDefaultApiErrors } from "@features/errors/hooks/use-ignore-default-api-errors";
import { useQuery } from "@tanstack/react-query";

import { requisitesApi } from "@shared/api";

import { constants } from "./constants";

interface UseBankInfoByBikParams {
  bik: string;
  enabled: boolean;
}

// Lookup failures are an expected outcome (unknown/typo BIK) and must not
// surface a global error toast — the form stays available for manual input.
const ignoredErrors = ["ErrNotFound", "ErrInvalidBik"] as const;

export const useBankInfoByBik = ({ bik, enabled }: UseBankInfoByBikParams) => {
  useIgnoreDefaultApiErrors(ignoredErrors);

  const { data } = useQuery({
    enabled,
    queryFn: () => requisitesApi.getApiV1BankBikBik({ bik }),
    queryKey: constants.bankInfoByBik(bik),
    select: (response) => response.data,
    staleTime: Infinity,
  });

  return { bankInfo: data };
};
